import { ArrowLeft, Calendar, Moon, Users } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { formatShortDate } from '../utils/dates';

interface SearchContextBarProps {
  startDate?: string;
  nights?: number;
  guests?: number;
  backLabel?: string;
  backTo?: string;
  backRouteParams?: Record<string, string>;
  backParams?: Record<string, unknown>;
}

export function SearchContextBar({
  startDate,
  nights,
  guests,
  backLabel = 'Back to Search',
  backTo = '/search',
  backRouteParams,
  backParams,
}: SearchContextBarProps) {
  const navigate = useNavigate();
  const hasContext = !!(startDate || nights || guests);

  const searchParams = {
    ...(startDate ? { startDate } : {}),
    ...(nights ? { nights } : {}),
    ...(guests ? { guests } : {}),
    ...backParams,
  };

  return (
    <div className="flex items-center gap-3 mb-6 flex-wrap">
      <button
        type="button"
        onClick={() =>
          navigate({
            to: backTo as never,
            ...(backRouteParams ? { params: backRouteParams as never } : {}),
            search: searchParams as never,
          })
        }
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        {backLabel}
      </button>

      {hasContext && (
        <div className="flex items-center gap-1.5 flex-wrap">
          {startDate && (
            <span className="inline-flex items-center gap-1 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700">
              <Calendar className="w-3.5 h-3.5 text-gray-400" />
              {formatShortDate(startDate)}
            </span>
          )}
          {nights && (
            <span className="inline-flex items-center gap-1 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700">
              <Moon className="w-3.5 h-3.5 text-gray-400" />
              {nights} night{nights !== 1 ? 's' : ''}
            </span>
          )}
          {guests && (
            <span className="inline-flex items-center gap-1 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700">
              <Users className="w-3.5 h-3.5 text-gray-400" />
              {guests} guest{guests !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
